export default __webpack_public_path__ + "static/media/ansh_modal_backgrnd.20a24196.png";